// Inline SVG icon set: 24×24 geometry, 1.5px strokes (non-scaling, see base.css), colour from currentColor.

const circle = (cx, cy, r) => `M${cx - r} ${cy}a${r} ${r} 0 1 0 ${r * 2} 0a${r} ${r} 0 1 0 ${-r * 2} 0`;

const PATHS = {
  plus: ['M12 5v14', 'M5 12h14'],
  search: [circle(11, 11, 6.5), 'M20 20l-4.4-4.4'],
  settings: ['M4 7h9', 'M19 7h1', 'M4 17h1', 'M11 17h9', circle(16, 7, 2.5), circle(8, 17, 2.5)],
  dashboard: ['M4 5a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z', 'M13 5a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1z', 'M13 12a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1z', 'M4 16a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z'],
  // Briefcase (client accounts) — People keeps the two-person glyph so the icon rail can tell them apart.
  clients: ['M4 8.5a1.5 1.5 0 0 1 1.5-1.5h13A1.5 1.5 0 0 1 20 8.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 17.5z', 'M9 7V5.5A1.5 1.5 0 0 1 10.5 4h3A1.5 1.5 0 0 1 15 5.5V7', 'M4 12.5h16', 'M11 12.5v1.5h2v-1.5'],
  calendar: ['M5 5h14a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z', 'M4 10h16', 'M8 3v4', 'M16 3v4'],
  performance: ['M4 4v15a1 1 0 0 0 1 1h15', 'M8 15l3.5-4 3 2.5L20 7'],
  chevronLeft: ['M15 18l-6-6 6-6'],
  chevronRight: ['M9 18l6-6-6-6'],
  chevronDown: ['M6 9l6 6 6-6'],
  arrowRight: ['M5 12h14', 'M13 6l6 6-6 6'],
  external: ['M14 4h6v6', 'M20 4l-9 9', 'M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5'],
  check: ['M5 12.5l4.5 4.5L19 7.5'],
  x: ['M6 6l12 12', 'M18 6L6 18'],
  more: [circle(5, 12, 1), circle(12, 12, 1), circle(19, 12, 1)],
  edit: ['M4 20h4L19 9a2.1 2.1 0 0 0-3-3L5 17z', 'M14.5 7.5l2 2'],
  trash: ['M4 7h16', 'M10 11v6', 'M14 11v6', 'M6 7l1 12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l1-12', 'M9 7V4.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5V7'],
  doc: ['M14 3H7a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7z', 'M14 3v4h4', 'M9 12h6', 'M9 16h6'],
  folder: ['M3 7a1 1 0 0 1 1-1h5l2 2h9a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z'],
  clock: [circle(12, 12, 8.5), 'M12 7.5V12l3 2'],
  user: [circle(12, 8, 4), 'M4.5 20.5c0-4 3.4-6.5 7.5-6.5s7.5 2.5 7.5 6.5'],
  link: ['M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1', 'M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1'],
  logout: ['M9 20H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h4', 'M15 16l4-4-4-4', 'M19 12H9'],
  key: [circle(7.5, 15.5, 4.5), 'M10.7 12.3L20 3', 'M16.5 6.5l3 3', 'M14 9l2.5 2.5'],
  alert: [circle(12, 12, 8.5), 'M12 7.5v5', circle(12, 16, 0.4)],
  // v2.1 shell
  overview: ['M4 4h6.5v6.5H4z', 'M13.5 4H20v6.5h-6.5z', 'M4 13.5h6.5V20H4z', 'M13.5 13.5H20V20h-6.5z'],
  workspace: ['M12 3.5l8.5 4.5-8.5 4.5L3.5 8z', 'M3.5 12l8.5 4.5 8.5-4.5', 'M3.5 16l8.5 4.5 8.5-4.5'],
  people: [circle(9, 8, 3.5), 'M3 20c0-3.3 2.7-5.5 6-5.5s6 2.2 6 5.5', 'M15.5 4.6a3.5 3.5 0 0 1 0 6.8', 'M18 14.9c1.8.6 3 2.4 3 5.1'],
  moon: ['M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5z'],
  sun: [circle(12, 12, 4), 'M12 2.5v2', 'M12 19.5v2', 'M2.5 12h2', 'M19.5 12h2', 'M5.3 5.3l1.4 1.4', 'M17.3 17.3l1.4 1.4', 'M5.3 18.7l1.4-1.4', 'M17.3 6.7l1.4-1.4'],
  refresh: ['M20 11a8 8 0 0 0-14.3-4.9L4 8', 'M4 4v4h4', 'M4 13a8 8 0 0 0 14.3 4.9L20 16', 'M20 20v-4h-4'],
  bell: ['M6 16V11a6 6 0 0 1 12 0v5l1.5 2h-15z', 'M10 20.5a2 2 0 0 0 4 0'],
  menu: ['M4 7h16', 'M4 12h16', 'M4 17h16'],
  chevronUp: ['M6 15l6-6 6 6'],
  chevronsUpDown: ['M8 9l4-4 4 4', 'M8 15l4 4 4-4'],
  arrowUpRight: ['M7 17L17 7', 'M8 7h9v9'],
  arrowDownRight: ['M7 7l10 10', 'M17 8v9H8'],
  trendUp: ['M3 17l6-6 4 4 8-8', 'M15 7h6v6'],
  trendDown: ['M3 7l6 6 4-4 8 8', 'M15 17h6v-6'],
  circle: [circle(12, 12, 7)],
  square: ['M7 7h10v10H7z'],
  play: ['M8 5.5v13l10-6.5z'],
  checkCircle: [circle(12, 12, 8.5), 'M8.5 12.2l2.4 2.4 4.6-4.9'],
  userSwitch: [circle(10, 8, 3.5), 'M4 20c0-3.3 2.7-5.5 6-5.5 1.3 0 2.5.3 3.4.9', 'M16 14l3-3 3 3', 'M19 11v9'],
  inbox: ['M4 13l2.5-7.5a1 1 0 0 1 1-.5h9a1 1 0 0 1 1 .5L20 13v6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z', 'M4 13h4.5l1.5 2.5h4l1.5-2.5H20'],
};

export const ICON_NAMES = Object.keys(PATHS);

export function Icon({ name, size = 16, class: cls, className, ...rest }) {
  const paths = PATHS[name];
  if (!paths) return null;
  return (
    <svg
      class={['icon', cls, className].filter(Boolean).join(' ')}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      {paths.map((d, i) => <path key={i} d={d} />)}
    </svg>
  );
}
